module.exports = __webpack_public_path__ + "static/img/socketio.48d9138f.gif";